import { render, staticRenderFns } from "./record.vue?vue&type=template&id=70cfdb0e&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=70cfdb0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfdb0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cfdb0e')) {
      api.createRecord('70cfdb0e', component.options)
    } else {
      api.reload('70cfdb0e', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=70cfdb0e&scoped=true", function () {
      api.rerender('70cfdb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/record.vue"
export default component.exports